// Utils
import ActionsUtil from '../utils/ActionsUtil';

export const setProject = (action) => async (dispatch, getState) => {
    dispatch({ type: 'SET_PROJECT', data: action });
    return Promise.resolve();
};

export const setNewProject = (properties) => async (dispatch, getState) => {
    dispatch({ type: 'SET_NEW_PROJECT', data: properties });
    return Promise.resolve();
};

export const setRights = (rights) => async (dispatch, getState) => {
    dispatch({ type: 'SET_RIGHTS', data: rights });
    return Promise.resolve();
};

export const setActions = (properties) => async (dispatch, getState) => {
    dispatch({ type: 'SET_ACTIONS', data: properties });
    return Promise.resolve();
};

export const setActionOccurrences = (occurrences, series) => async (dispatch, getState) => {
    const state = getState();
    const actionSeries = series !== undefined ? series : state.actionSeries;
    dispatch({ type: 'SET_ACTION_OCCURRENCES', data: { occurrences, series: actionSeries } });
    return Promise.resolve(occurrences);
};

// Fusionne dans Redux les occurrences et séries renvoyées par l'API, à partir de l'état courant du store
export const mergeActionOccurrences = (changes, seriesChanges) => async (dispatch, getState) => {
    const state = getState();
    const occurrences = ActionsUtil.mergeOccurrences(state.actionOccurrences, changes);
    const series = seriesChanges ? ActionsUtil.mergeSeries(state.actionSeries, seriesChanges) : undefined;
    return dispatch(setActionOccurrences(occurrences, series));
};

// Retire du store les occurrences et appartenances d'éléments supprimés (message temps réel), à partir de l'état courant
export const removeElementsFromActionOccurrences = (elementIds) => async (dispatch, getState) => {
    const ids = new Set(elementIds);
    const { actionOccurrences, actionSeries } = getState();
    if (!actionOccurrences?.length && !actionSeries?.length) return actionOccurrences;
    const removedIds = (actionOccurrences || []).filter(occurrence => ids.has(occurrence.elementId)).map(occurrence => occurrence.id);
    const updated = (actionSeries || []).filter(s => s.elements.some(element => ids.has(element.elementId)))
        .map(s => ({ ...s, elements: s.elements.filter(element => !ids.has(element.elementId)) }));
    return dispatch(mergeActionOccurrences({ removedIds }, updated.length ? { updated } : undefined));
};

export const setProjectEvents = (ProjectEvents) => async (dispatch, getState) => {
    dispatch({ type: 'SET_PROJECT_EVENTS', data: ProjectEvents });
    return Promise.resolve();
};

// Fusionne dans Redux des évènements (catalogue « event » rattaché), à partir de l'état courant du store
export const mergeProjectEvents = ({ created = [], updated = [], removedIds = [] } = {}) => async (dispatch, getState) => {
    const { projectEvents, events } = getState();
    const eventsById = new Map((events || []).map(event => [event.id, event]));
    const projectEventsById = new Map((projectEvents || []).map(projectEvent => [projectEvent.id, projectEvent]));
    [...created, ...updated].forEach(projectEvent => projectEventsById.set(projectEvent.id, { ...projectEvent, event: projectEvent.event || eventsById.get(projectEvent.eventId) }));
    removedIds.forEach(id => projectEventsById.delete(id));
    await dispatch(setProjectEvents([...projectEventsById.values()]));
    return getState().projectEvents;
};

export const setRootBaseProjectIds = (properties) => async (dispatch, getState) => {
    dispatch({ type: 'SET_ROOT_BASE_PROJECT_ID', data: properties });
    return Promise.resolve();
};

export const setProjects = (properties) => async (dispatch, getState) => {
    dispatch({ type: 'SET_PROJECTS', data: properties });
    return Promise.resolve();
};

export const setProjectCustomFields = (projectId, customFields) => async (dispatch, getState) => {
    dispatch({ type: 'SET_PROJECT_CUSTOM_FIELDS', data: { projectId, customFields } });
    return Promise.resolve();
};

export const setProjectsCustomFields = (projectCustomFields) => async (dispatch, getState) => {
    dispatch({ type: 'SET_PROJECTS_CUSTOM_FIELDS', data: projectCustomFields });
    return Promise.resolve();
};

export const setUserProjects = (userProjects) => async (dispatch, getState) => {
    dispatch({ type: 'SET_USER_PROJECTS', data: userProjects });
    return Promise.resolve();
};

export const setProjectCollaborators = (projectCollaborators) => async (dispatch, getState) => {
    dispatch({ type: 'SET_PROJECT_COLLABORATORS', data: projectCollaborators });
    return Promise.resolve();
};

export const setProjectInvitations = (projectInvitations) => async (dispatch, getState) => {
    dispatch({ type: 'SET_PROJECT_INVITATIONS', data: projectInvitations });
    return Promise.resolve();
};

export const setViewProjectAsData = (viewProjectAsData) => async (dispatch, getState) => {
    dispatch({ type: 'SET_VIEW_PROJECT_AS_DATA', data: viewProjectAsData });
    return Promise.resolve();
};

export const setBaseProjectDataLoadingStatus = (partialStatus) => (dispatch) => {
    dispatch({
        type: 'SET_BASE_PROJECT_DATA_LOADING_STATUS',
        data: partialStatus
    });
    return Promise.resolve();
};